import {ViewStatus} from "enums/viewStatus";

export const errorStatuses = [
  ViewStatus.ValidationError,
  ViewStatus.Error,
  ViewStatus.SecurityError,
];